import { render, staticRenderFns } from "./artigos.vue?vue&type=template&id=361f8a4e&scoped=true&"
import script from "./artigos.vue?vue&type=script&lang=js&"
export * from "./artigos.vue?vue&type=script&lang=js&"
import style0 from "./artigos.vue?vue&type=style&index=0&id=361f8a4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f8a4e",
  null
  
)

export default component.exports